import React from 'react';
import { toArabicDigits } from '../../utils/numbers';

const Pagination = ({ postsPerPage, totalPosts, paginate, currentPage }) => {
  const totalPages = Math.ceil(totalPosts / postsPerPage);

  const handleNext = () => {
    if (currentPage < totalPages) {
      paginate(currentPage + 1);
    }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      paginate(currentPage - 1);
    }
  };

  return (
    <div
      className="w-full flex justify-between items-center px-4 py-8 mt-4 border-t border-[#E5E5E5]/30 relative z-50"
      dir="rtl"
    >
      {/* Right Element (Next) */}
      <button
        onClick={handleNext}
        disabled={currentPage === totalPages}
        className="text-[#C5A059] font-bold text-lg hover:underline disabled:opacity-30 cursor-pointer disabled:cursor-not-allowed transition-opacity"
        style={{ fontFamily: 'Amiri, serif' }}
      >
        التالي &gt;
      </button>

      {/* Center Element (Info) */}
      <span
        className="text-[#1F1F1F] text-base tracking-wide"
        style={{ fontFamily: 'Amiri, serif' }}
      >
        صفحة {toArabicDigits(currentPage)} من {toArabicDigits(totalPages)}
      </span>

      {/* Left Element (Previous) */}
      <button
        onClick={handlePrev}
        disabled={currentPage === 1}
        className="text-[#C5A059] font-bold text-lg hover:underline disabled:opacity-30 cursor-pointer disabled:cursor-not-allowed transition-opacity"
        style={{ fontFamily: 'Amiri, serif' }}
      >
        &lt; السابق
      </button>
    </div>
  );
};

export default Pagination;